function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityStairsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 22v6h2v-4h5v-5h5v-5h5V9h5V4h6a2 2 0 00-2-2h-6v5h-5v5h-5v5H7v5H2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 30H4a2 2 0 01-2-2h26V4h2v24a2 2 0 01-2 2z",
    fill: props.color
  }));
}

export default SvgIconFacilityStairsFilled;